import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  styleGuideContainer: {
    marginLeft: '10px',
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  styleGuideTitle: {
    fontWeight: tokens.fontWeightBold,
    paddingBottom: '5px',
  },
  styleColorTitle: {
    paddingTop: '5px',
    paddingBotton: '5px',
    fontWeight: tokens.fontWeightSemibold,
  },
  colorPalettes: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
    ...shorthands.margin(tokens.spacingVerticalM, 0, 0, 0),
  },
  item: {
    height: '55px',
    width: '55px',
    backgroundColor: tokens.colorNeutralStencil1,
  },
  textDivider: {
    ...shorthands.margin(tokens.spacingVerticalL, 0),
  },
  containerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalL,
  },
  container: {
    width: '100%',
    ...shorthands.flex(1),
    ...shorthands.padding(tokens.spacingVerticalS, 0),
  },
  header: {
    display: 'flex',
    columnGap: tokens.spacingHorizontalXS,
    alignItems: 'center',
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL),
  },
  content: {
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL),
  },
  fontSelect: {
    minWidth: 'auto',
    maxWidth: '100%',
    '& > input': {
      maxWidth: '120px',
    },
  },
  fontWeightSelect: {
    minWidth: 'auto',
    maxWidth: '100%',
    '& > input': {
      maxWidth: '120px',
    },
  },
  fontContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(172px, 1fr))',
    gridGap: tokens.spacingHorizontalS,
  },
  contentDivider: {
    display: 'inline-flex',
    marginTop: tokens.spacingVerticalXL,
  },
});

export const getskeletonStyles = makeStyles({
  row: {
    display: 'flex',
    ...shorthands.gap('8px'),
    flexWrap: 'wrap',
  },
  item: {
    height: '55px',
    width: '55px',
    backgroundColor: tokens.colorNeutralStencil1,
  },
});
